module.exports = __webpack_public_path__ + "arrow_left.270f72df47e036d9cfa1.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/img/svg/arrow_left.svg
// module id = ../../../../../src/img/svg/arrow_left.svg
// module chunks = 1